import React from 'react';

interface QRGeneratorProps {
  value: string;
  size?: number;
  label?: string;
  description?: string;
}

const QRGenerator: React.FC<QRGeneratorProps> = ({ value, size = 180, label, description }) => {
  // Käytetään luotettavaa QR-rajapintaa. Asetetaan värit vastaamaan teemaa (bg: slate-950, fg: teal-400)
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(value)}&bgcolor=0b1120&color=2dd4bf&format=svg`;

  return (
    <div className="flex flex-col items-center p-8 arctic-panel rounded-[2.5rem] border border-teal-400/20 bg-teal-500/5 my-8 relative overflow-hidden group">
      <div className="absolute -top-10 -right-10 w-24 h-24 bg-teal-400/10 rounded-full blur-2xl group-hover:bg-teal-400/20 transition-colors"></div>
      
      {label && (
        <span className="text-[10px] font-black text-teal-300 uppercase tracking-[0.3em] mb-6 relative z-10">
          {label}
        </span>
      )}
      
      <div className="p-4 bg-slate-950 rounded-2xl border border-teal-400/30 shadow-2xl shadow-teal-500/10 relative z-10 transition-transform group-hover:scale-105 duration-500">
        <img 
          src={qrUrl} 
          alt={`QR koodi: ${value}`} 
          width={size} 
          height={size}
          className="rounded-lg"
          loading="lazy"
        />
      </div>
      
      {description && (
        <p className="mt-6 text-xs text-slate-400 text-center leading-relaxed font-medium max-w-[220px] relative z-10">
          {description}
        </p>
      )}
      
      <div className="mt-4 px-3 py-1 bg-slate-900/80 rounded-full border border-slate-800 relative z-10">
        <code className="text-[9px] text-slate-500 font-mono break-all">
          {value.length > 30 ? value.substring(0, 27) + '...' : value}
        </code>
      </div>
    </div>
  );
};

export default QRGenerator;
